import React from 'react';
import { describeOpportunityType } from '../utils/opportunityTypes';

const OpportunityTypeBadge: React.FC<{ value?: string | null }> = ({ value }) => {
  if (!value) return null;
  return (
    <span
      className="inline-flex w-fit rounded-full border border-blue-200 bg-blue-50 px-2.5 py-1 text-xs font-semibold text-blue-700"
      title={describeOpportunityType(value)}
    >
      {value}
    </span>
  );
};

export default OpportunityTypeBadge;

